import React, { Component } from "react";
import DashboardCtrl from "./DashboardCtrl";
import Message from "./Message";

class Dashboard extends Component {
  render() {
    return (
      <div className="content-wrapper">
        <section className="content">
          {/* <Message {...this.props}/> */}
          <DashboardCtrl {...this.props} />
        </section>
      </div>
    );
  }
}

export default Dashboard;
